import baseAxios from "axios";

const api = baseAxios.create({});
export default api
